import { FlaskConical, Radio } from "lucide-react";
import { getEnvironment } from "@ir/config";
import { Badge } from "@ir/ui";

/**
 * Environment indicator.
 * UAT and production are separate frontend deployments, so changing
 * environment should be a deliberate URL/navigation choice rather than a
 * data-mode toggle inside the app.
 */
export function EnvironmentBadge() {
  const environment = getEnvironment();

  if (environment === "local") {
    return (
      <Badge tone="neutral" icon={FlaskConical}>
        Local development
      </Badge>
    );
  }

  const isLive = environment === "live";

  return (
    <Badge tone={isLive ? "crimson" : "warning"} icon={isLive ? Radio : FlaskConical}>
      {isLive ? "Live data" : "UAT data"}
    </Badge>
  );
}
